import type { AssetTypePageTabsProps } from "./asset-type-page-tabs.type";
import type { TabItem } from "@/ui/context-tabs";

import { useTranslation } from "react-i18next";

import { TAB_KEYS } from "@/constants/TabKeys";
import { useFeatureFlag } from "@/hooks/useFeatureFlag";
import AssetTypeDetailsTab from "@/modules/asset-type/asset-type-details-tab";
import { AssetTypeSeverityGridTab } from "@/modules/asset-type/asset-type-severity-grid-tab";
import { ContextTabs } from "@/ui/context-tabs";

const AssetTypePageTabs = ({ assetType, loading }: AssetTypePageTabsProps) => {
  const { t } = useTranslation();
  const isFeatureSeverityGridEditorOn = useFeatureFlag("dev2579");

  const tabs: TabItem[] = [
    {
      key: TAB_KEYS.TEMPLATE_DETAILS,
      label: t("global:details"),
      children: <AssetTypeDetailsTab assetType={assetType} />,
    },
  ];

  if (isFeatureSeverityGridEditorOn) {
    tabs.push({
      key: TAB_KEYS.TEMPLATE_SEVERITY_GRID,
      label: t("form:severityGridEditor.title"),
      children: (
        <AssetTypeSeverityGridTab assetType={assetType} loading={loading} />
      ),
    });
  }

  return <ContextTabs items={tabs} />;
};

export default AssetTypePageTabs;
